import { Component, OnInit, ViewChild } from '@angular/core';
import { AppInformationService, AuthService, EntitiesService, GenesisUnitOfWork, UtilityService } from 'app/core/core.module';
import { Part } from 'app/core/model/entity-model';
import { PartSearchComponent } from 'app/parts/part-search/part-search.component';
import { InputDialogComponent } from 'app/shared/input-dialog/input-dialog.component';
import { DxDataGridComponent } from 'devextreme-angular';
import { confirm } from 'devextreme/ui/dialog';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-order-option-dialog',
    templateUrl: './order-option-dialog.component.html',
    styleUrls: ['./order-option-dialog.component.scss'],
    standalone: false
})
export class OrderOptionDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    parts: any;
    partTypeIds: any[];
    filter: any = { partId: null, quantity: 0 };
    miscDescription: any;

    options: any[];
    availableOptions: any;
    orderLineDetail: any;

    entityId: any;
    deleteMode: string;
    @ViewChild('optionsGrid') optionsGrid: DxDataGridComponent;

    constructor(
        public modalRef: BsModalRef,
        private uow: GenesisUnitOfWork,
        private appInfo: AppInformationService,
        private modalService: BsModalService,
        private entitiesService: EntitiesService,
        private auth: AuthService,
        private utility: UtilityService
    ) {}

    async ngOnInit() {
        this.getData();
    }

    getData() {
        this.options = this.options.filter((x) => {
            return !x.deleted;
        });
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'toolbarButtons',
        });
    }


    async addMultiple() {
        const line = this.optionsGrid.instance.getSelectedRowsData()[0];
        const partOptions = this.availableOptions;
        const mode = 'Options';

        const modalRef = this.modalService.show(PartSearchComponent, {
            class: 'modal-lg',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                showAsDialog: true,
                partOptions: this.availableOptions,
                mode: 'Options',
                columnLimitMode: true,
                showSideBar: true,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                this.appInfo.pleaseWaitShow();
                const parts = (await this.uow.parts.byIds(result.partIds)) as Part[];
                const orderLineDetails = [];
                for (let index = 0; index < result.partIds.length; index++) {
                    const element = result.partIds[index];
                    const part = parts.filter((p) => p.id === element)[0];

                    // look for the Misc line and ask for a description
                    if (part.partNumber === 'Miscellaneous') {
                        this.miscDescription = await this.getMiscDescription();
                    } else this.miscDescription = null;

                    // add the orderLine
                    const orderLine = this.entitiesService.addOrderLine(
                        part,
                        1,
                        this.orderLineDetail.orderLine.id,
                        this.orderLineDetail.orderLine.order,
                        null,
                        this.miscDescription
                    );
                    // add the OrderLineDetail
                    const newOrderLineDetail = this.entitiesService.addOrderLineDetail(
                        orderLine,
                        this.auth.currentUser.id,
                        this.orderLineDetail.id,
                        this.orderLineDetail.packingSlipId,
                        this.orderLineDetail.statusId
                    );
                    this.options.push(newOrderLineDetail);
                    orderLineDetails.push(newOrderLineDetail);
                    // add the OrderLineDetailNote
                    this.entitiesService.createOrderLineDetailNote(this.orderLineDetail.id, 'Option Added', this.auth.currentUser.id, 3);
                }
                await this.uow.commit();
                this.utility.processOrderLineDetails(orderLineDetails.map((x) => x.id));
                this.getData();
                this.appInfo.pleaseWaitHide();
            }
            // pass the orderline detail id

            modalRef.hide();
        });
    }

    async getMiscDescription(): Promise<any> {
        this.appInfo.pleaseWaitHide();
        const modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: 'Add Miscellaneous Description',
                dialogPrompt: 'Enter Description',
                checkNumeric: false,
                checkInteger: false,
                mode: 'text',
            },
        });

        const promise = new Promise<any>(async (resolve, reject) => {
            modalRef.content.result.subscribe(async (result) => {
                if (result.result && !!result.value) {
                    resolve(result.value);
                }
                modalRef.hide();
                this.appInfo.pleaseWaitShow();
                resolve(null);
            });
        });
        return promise;
    }

    async delete() {
        const selectedOption = this.optionsGrid.instance.getSelectedRowsData()[0];
        if (!selectedOption) return;

        const result = await (confirm(
            `Are you sure you want to DELETE this option?\r\nThis will place all parts used to make this option back into inventory.`,
            `${this.appInfo.settings.company}`
        ) as Promise<boolean>);
        if (!result) return;
        this.appInfo.pleaseWaitShow();

        if (this.deleteMode === 'old') {
            // add orderLine for negative
            const orderLine = this.entitiesService.addOrderLine(selectedOption.orderLine.part, -1, this.orderLineDetail.orderLine.id, this.orderLineDetail.orderLine.order);
        } else {
            selectedOption.orderLine.deleted = new Date();
        }

        // need to call function to remove the OrderLineDetailParts
        await this.utility.deleteOrderLineDetail(selectedOption.id);
        this.entitiesService.createOrderLineDetailNote(selectedOption.parentLineId, 'Option Deleted', this.auth.currentUser.id);
        selectedOption.deleted = new Date();
        await this.uow.commit();

        this.appInfo.pleaseWaitHide();
        this.options.splice(this.options.indexOf(selectedOption), 1);
    }

    async inventoryAdjustment() {}

    async save() {
        this.result.next({ success: true, partId: this.filter.partId, quantity: this.filter.quantity, options: this.options });
        this.modalRef.hide();
    }

    cancel() {
        // this.uow.rollback();
        this.modalRef.hide();
    }
}
